import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import {
	getAssetsReportingConfig,
	type AssetsReportingConfig,
} from './getAssetsReportingConfig.tsx';

export const RESOURCE_ASSETS_REPORTING_CONFIG = 'assets-reporting-config';
export const RESOURCE_ASSETS_REPORTING_CONFIG_KEY = 'assets.reporting.config';

export const assetsReportingConfigResource: RouteResource<AssetsReportingConfig> =
	createResource<AssetsReportingConfig>({
		type: RESOURCE_ASSETS_REPORTING_CONFIG,
		getKey: () => RESOURCE_ASSETS_REPORTING_CONFIG_KEY,
		getData: async () => getAssetsReportingConfig(),
		maxAge: __SERVER__ ? 0 : Number.MAX_SAFE_INTEGER,
		isCritical: true,
	});

export const useAssetsReportingConfigResource =
	(): UseResourceHookResponse<AssetsReportingConfig> =>
		useResource<AssetsReportingConfig>(assetsReportingConfigResource);
